import { render } from "./DanhSachLenh.vue?vue&type=template&id=8a1e315a&scoped=true"
import script from "./DanhSachLenh.vue?vue&type=script&lang=js"
export * from "./DanhSachLenh.vue?vue&type=script&lang=js"

import "./DanhSachLenh.vue?vue&type=style&index=0&id=8a1e315a&scoped=true&lang=css"
import "./DanhSachLenh.vue?vue&type=style&index=1&id=8a1e315a&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1e315a"]])

export default __exports__